import React, { useEffect, useState } from 'react'
import { Drawer, IconButton, Box, Typography, useTheme, Collapse, SwipeableDrawer, Tooltip } from '@mui/material'
import { Icons } from '../../../../shared/utils/icons.jsx'
import { ALIVE_SUPPORT_URL, ERPStudentDashboardPageURL } from '../../../../shared/utils/constants.jsx'
import { Link } from 'react-router-dom'
import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import aliveLogo from '../../../../shared/assets/alivelogo.png'

const closedSidebarWidth = 60

const getCodingLabsLink = () => {
    const prod = true
    const baseUrl = prod ? `https://codelabs.alive.university` : `http://localhost:5173`

    if ( sessionStorage.getItem( "impersonation_id_token" ) )
        return `${baseUrl}/sso?token=${sessionStorage.getItem( "impersonation_id_token" )}`
    return `${baseUrl}/sso?token=${localStorage.getItem( 'id_token' )}`
}

const menu = [
    { id: "menuitem-home", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/student\/home)\/?$/], label: "Home", children: null, link: `/student/home`, icon: Icons.default.HomeIconOutlined, activeIcon: Icons.default.HomeIcon },
    // { id: "menuitem-subjects", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/subjects)\/?$/, /^(\/student\/subject\/\d+)\/?$/, /^(\/student\/subject\/\d+\/\w+)\/?$/], label: "Subjects", children: null, link: `/student/subjects`, icon: Icons.default.SubjectsOutlined, activeIcon: Icons.default.Subjects },
    { id: "menuitem-materials", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/student\/material)\/?$/, /^(\/student\/material\/\d+)\/?$/], label: "Study Materials", children: null, link: `/student/material`, icon: Icons.default.DescriptionIconOutlined, activeIcon: Icons.default.DescriptionIcon },
    { id: 'menuitem-class-resources', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/class-sessions)\/?$/, /^(\/student\/class-sessions\/\d+)\/?$/], permission: true, label: "Beyond Class Resources", children: null, link: `/student/class-sessions`, icon: Icons.default.ClassOutlined, activeIcon: Icons.default.Class },
    { id: "menuitem-assignments", view: ["left-panel", "bleeding-bottom-bar"], activeMatchRegexes: [/^(\/student\/assignment)\/?$/, /^(\/student\/assignment\/\d+)\/?$/], label: "Assignments", children: null, link: `/student/assignment`, icon: Icons.default.AssignmentIconOutlined, activeIcon: Icons.default.AssignmentIcon },
    { id: "menuitem-exams", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/exams)\/?$/, /^(\/student\/exams\/\d+)\/?$/, /^(\/student\/scores)\/?$/, /^(\/student\/scores\/\d+\/\d+)\/?$/, /^(\/student\/exams\/\d+\/attempt\/\d+\/\d+)\/?$/], label: "Exams", children: null, link: "/student/exams", activeIcon: Icons.default.QuizIcon, icon: Icons.default.QuizIconOutlined },
    { id: 'menuitem-hybrid-classes', view: ["left-panel", "opened-bottom-bar"], headerText: "Hybrid Classes", activeMatchRegexes: [/^(\/student\/hybrid-classes)\/?$/, /^(\/student\/hybrid-class\/[\w-]+)\/?$/], permission: true, label: "Hybrid Classes", children: null, link: "/student/hybrid-classes", activeIcon: Icons.default.HybridClasses, icon: Icons.default.HybridClassesOutlined },
    { id: "menuitem-discussions", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/discussions)\/?$/, /^(\/student\/discussion\/\w+)\/?$/, /^(\/student\/my-discussions)\/?$/, /^(\/student\/my-discussions\/\w+)\/?$/], permission: true, label: "Discussions", children: null, link: "/student/discussions", childrenIcons: [{ default: Icons.default.QuestionMarkOutlined, activeIcon: Icons.default.QuestionMark }, { default: Icons.default.BadgeOutlined, activeIcon: Icons.default.Badge }], activeIcon: Icons.default.Discussions, icon: Icons.default.DiscussionsOutlined },
    { id: "menuitem-codelabs", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], secondaryIcon: Icons.default.OpenInNewIcon, target: "_blank", label: "Coding labs", new: true, children: null, link: getCodingLabsLink, activeIcon: Icons.default.CodeLab, icon: Icons.default.CodeLab },
    { id: "menuitem-resumebuilder", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/resume-builder)\/?$/, /^(\/student\/resume-builder\/preview)\/?$/], label: "Resume Builder", children: null, link: "/student/resume-builder", activeIcon: Icons.default.Protrait, icon: Icons.default.ProtraitOutlined },
    { id: "menuitem-faq", view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [/^(\/student\/faq)\/?$/], label: "FAQs", children: null, link: `/student/faq`, activeIcon: Icons.default.LiveHelpIcon, icon: Icons.default.LiveHelpIconOutlined },
    { id: "menuitem-support", view: ["left-panel", "opened-bottom-bar"], secondaryIcon: Icons.default.OpenInNewIcon, activeMatchRegexes: [], target: "_blank", permission: true, label: "Support", children: null, link: ALIVE_SUPPORT_URL, icon: Icons.default.SupportAgentOutlined, activeIcon: Icons.default.SupportAgent },
    { id: 'menuitem-erp', view: ["left-panel", "opened-bottom-bar"], activeMatchRegexes: [], permission: true, label: "ERP", children: null, link: ERPStudentDashboardPageURL, icon: Icons.default.Logout, activeIcon: Icons.default.Logout },
]

export const EcosystemPortalCard = ( { isSideDrawerCollapsed } ) => {
    const theme = useTheme()
    const isDark = theme.palette.mode === 'dark'

    return (
        <Link
            to="/placements"
            target="_placements"
            className="default-link"
            style={{ textDecoration: 'none', display: 'block', width: '100%', position: "sticky", bottom: 0, marginTop: "20px" }}
        >
            <Box
                sx={{
                    position: 'sticky',
                    bottom: 0,
                    overflow: 'hidden',
                    borderRadius: 2.5,
                    p: isSideDrawerCollapsed ? 0 : 1,
                    cursor: 'pointer',
                    width: '100%',

                    background: isDark
                        ? `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[900]} 100%)`
                        : `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.secondary.light} 100%)`,

                    color: theme.palette.text.primary,
                    border: '1px solid transparent',
                    borderColor: isDark
                        ? 'rgba(255, 255, 255, 0.12)'
                        : 'rgba(0, 0, 0, 0.08)',

                    boxShadow: isDark
                        ? '0 4px 20px rgba(0, 0, 0, 0.4)'
                        : '0 4px 20px rgba(0, 0, 0, 0.05)',

                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

                    '&:hover': {
                        transform: 'translateY(-2px)',
                        borderColor: theme.palette.secondary.main,
                        boxShadow: isDark
                            ? `0 8px 25px ${theme.palette.secondary.main}33`
                            : `0 8px 25px ${theme.palette.secondary.main}20`,
                        '& .arrow-icon': {
                            transform: 'translate(3px, -3px)',
                            color: theme.palette.secondary.main,
                            bgcolor: isDark ? 'rgba(255, 255, 255, 0.1)' : theme.palette.action.hover,
                        },
                        '& .bg-glow': {
                            opacity: isDark ? 0.25 : 0.4,
                            transform: 'scale(1.2)',
                        },
                    },
                }}
            >
                {/* Background Glow */}
                <Box
                    className="bg-glow"
                    sx={{
                        position: 'absolute',
                        top: -20,
                        right: -20,
                        width: 100,
                        height: 100,
                        borderRadius: '50%',
                        background: theme.palette.secondary.main,
                        opacity: isDark ? 0.12 : 0.15,
                        filter: 'blur(25px)',
                        transition: 'all 0.5s ease',
                        pointerEvents: 'none',
                    }}
                />

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
                    <Box sx={{ width: isSideDrawerCollapsed ? "100%" : "auto", display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {/* Icon Container */}
                        <Tooltip arrow placement="right" title={isSideDrawerCollapsed ? "Switch to Placements Portal" : ""}>
                            <Box
                                sx={{
                                    width: isSideDrawerCollapsed ? "100%" : "auto",
                                    p: 1.2,
                                    borderRadius: 2,
                                    bgcolor: isDark
                                        ? 'rgba(255, 255, 255, 0.06)'
                                        : 'rgba(0, 0, 0, 0.04)',
                                    color: theme.palette.secondary.main,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {Icons.default.Building1}
                            </Box>
                        </Tooltip>

                        {!isSideDrawerCollapsed && <Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                                <Typography
                                    noWrap
                                    variant="caption"
                                    sx={{
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.8,
                                        fontWeight: 700,
                                        fontSize: '0.65rem',
                                        color: theme.palette.secondary.main
                                    }}
                                >
                                    New Space
                                </Typography>
                            </Box>
                            <Typography
                                noWrap
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 600,
                                    lineHeight: 1.2,
                                    color: theme.palette.text.primary
                                }}
                            >
                                Placements Portal
                            </Typography>
                        </Box>}
                    </Box>

                    {/* Action Icon */}
                    {!isSideDrawerCollapsed && <Box
                        className="arrow-icon"
                        sx={{
                            display: 'inline-flex',
                            p: 0.8,
                            borderRadius: '50%',
                            color: theme.palette.text.secondary,
                            bgcolor: isDark ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.3s ease',
                        }}
                    >
                        {Icons.default.ArrowOutward}
                    </Box>}
                </Box>
            </Box>
        </Link>
    )
}

const SidedrawerMenuItem = ( { item, isActive, sidebarOpenState, closeOnMobileScreen, active } ) => {

    const { isSideDrawerCollapsed } = useLayoutContext()
    const [collapseState, setCollapseState] = useState( false )
    const { palette, layout } = useTheme()

    return <Box sx={{ borderRadius: layout.borderRadius, bgcolor: collapseState && palette.nav.sidebarHover }}>
        <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={isSideDrawerCollapsed ? item.label : ''}>
            <Link className='default-link' target={item.target} to={!item.children ? typeof item.link === 'string' ? item.link : item.link() : `#${item.label}`}>
                <Box
                    onClick={item.children ? () => setCollapseState( !collapseState ) : closeOnMobileScreen}
                    sx={{
                        color: isActive ? palette.nav.activeFont : palette.nav.font,
                        borderRadius: layout.borderRadius,
                        display: 'flex',
                        alignItems: 'center',
                        padding: 1,
                        paddingY: 0.5,
                        gap: '15px',
                        marginY: '2px',
                        minWidth: closedSidebarWidth - 20,
                        cursor: 'pointer',
                        position: 'relative',
                        background: isActive ? palette.nav.activeSidebarItem : 'none',
                        '&:hover': {
                            background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem,
                        },
                    }}
                >
                    <Typography sx={{ color: 'inherit', padding: '2px', position: 'relative', fontSize: '18px', display: 'flex', alignItems: 'center' }}>
                        {item.icon}
                    </Typography>
                    <Box sx={{ flexGrow: 1, gap: '5px', justifyContent: 'space-between', display: 'flex', alignItems: 'center', flexShrink: 0, color: 'inherit', fontWeight: isActive ? '500' : '300', fontSize: '14px', textAlign: 'center' }}>
                        <Typography noWrap sx={{ display: 'flex', gap: '5px', alignItems: 'center', fontWeight: isActive ? '500' : '400', opacity: !isSideDrawerCollapsed ? 1 : 0, fontSize: '14px', color: 'inherit' }}>
                            {item.label}
                        </Typography>
                        <Box component='span' sx={{ color: palette.text.secondary }}>
                            {item.children ? Icons.small.KeyboardArrowDown : item.secondaryIcon || ''}
                        </Box>
                    </Box>
                </Box>
            </Link>
        </Tooltip>
    </Box>
}

const SideDrawer = function ( { closeSideMenu } ) {
    const { sidebarOpenState, setNavHeadText, active, menuState, setMenuState, sidebarWidth, minSidebarCollapseWidth, setIsSideDrawerCollapsed, isSideDrawerCollapsed } = useLayoutContext()

    const { palette, layout } = useTheme()

    const closeOnMobileScreen = () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            closeSideMenu()
    }


    useEffect( () => {
        for ( let i = 0; i < menu.length; i++ ) {
            const item = menu[i]
            const isActive = item.activeMatchRegexes.flat().some( re => active.match( re ) )
            if ( isActive ) {
                setNavHeadText( item.label )
                break
            }
        }
    }, [active, setNavHeadText] )


    return (
        <Box>
            <Box sx={{
                display: { sm: "block", xs: "none" }
            }}>
                <Drawer
                    variant='persistent'
                    anchor='left'
                    open={true}
                    className='no-scrollbar'
                    slotProps={{
                        paper: {
                            className: 'no-scrollbar',
                            sx: {
                                width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth,
                                borderRadius: '0',
                                background: palette.nav.sidebar,
                                borderRight: 'none',
                                transition: '200ms',
                                overflowX: 'hidden',
                            },
                        },
                    }}
                    sx={{ background: 'transparent', position: 'initial', overflow: 'hidden', width: !isSideDrawerCollapsed ? sidebarWidth : closedSidebarWidth, height: '100%', flexShrink: 0, display: { sm: 'flex', xs: 'none' }, flexDirection: 'column' }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            flexGrow: 1,
                            overflow: "auto",
                            display: "flex"
                        }}>
                        <Box
                            className='sidebar-scrollbar'
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                overflowX: 'clip',
                                overflowY: 'auto',
                                color: 'GrayText',
                                alignItems: 'stretch',
                            }}
                        >
                            <Box sx={{ flexShrink: 0, mb: 2, display: 'flex', gap: '10px', padding: '8px 15px', alignItems: 'center' }}>
                                <Box sx={{ padding: 0.7, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px', bgcolor: 'white', aspectRatio: '1 / 1' }}>
                                    <Box component='img' src={aliveLogo} alt='Logo' sx={{ width: '20px' }} />
                                </Box>
                                <Box sx={{ opacity: !isSideDrawerCollapsed ? 1 : 0 }}>
                                    <Typography variant='h6' sx={{ color: palette.nav.font, fontSize: '14px' }}>Alive</Typography>
                                    <Typography variant='body2' noWrap sx={{ color: palette.nav.font, fontSize: '12px', fontWeight: '300' }}>Acharya LMS platform</Typography>
                                </Box>
                                <IconButton sx={{ color: palette.nav.font, display: { sm: 'none', xs: 'block' } }} onClick={() => setMenuState( false )}>
                                    {Icons.default.CloseIcon}
                                </IconButton>
                            </Box>
                            <Box className='sidebar-scrollbar' sx={{ padding: '0 10px 20px 10px', flexGrow: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto', overflowX: 'clip' }}>
                                {menu.map( item => {
                                    const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                    return (
                                        <SidedrawerMenuItem active={active} closeOnMobileScreen={closeOnMobileScreen} item={item} isActive={isActive} sidebarOpenState={sidebarOpenState} key={item.id} />
                                    )
                                } )}
                                <Box sx={{ flexGrow: 1 }} />
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                    <EcosystemPortalCard isSideDrawerCollapsed={isSideDrawerCollapsed} />
                                    <Box onClick={() => setIsSideDrawerCollapsed( prev => !prev )} sx={{ color: palette.nav.font, borderRadius: layout.borderRadius, display: 'flex', alignItems: 'center', padding: 1, gap: '15px', marginY: '2px', minWidth: closedSidebarWidth - 20, cursor: 'pointer', position: 'relative', background: 'none', '&:hover': { background: palette.nav.sidebarItemHoverBg } }}>
                                        <Tooltip placement='right' enterDelay={0} disableInteractive arrow title={!isSideDrawerCollapsed ? '' : 'Expand Sidebar'}>
                                            <IconButton color='inherit' disableFocusRipple disableRipple disableTouchRipple sx={{ padding: '2px', borderRadius: '5px', transform: 'scale(0.9)', position: 'relative', fontSize: '18px' }}>
                                                {!isSideDrawerCollapsed ? Icons.default.MenuClose : Icons.default.Menu}
                                            </IconButton>
                                        </Tooltip>
                                        <Typography noWrap sx={{ opacity: !isSideDrawerCollapsed ? 1 : 0, fontSize: '0.875rem' }}>Collapse Sidebar</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box >
                </Drawer >
            </Box>
            <Box sx={{
                display: { sm: "none", xs: "block" }
            }}>
                <Box
                    sx={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        padding: "10px 20px",
                        background: palette.layoutBackground
                    }}>
                    {menu.filter( item => item.view.includes( "bleeding-bottom-bar" ) ).map( item => {
                        const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                        return (
                            <Box key={item.id}>
                                <Link to={item.link} className='default-link' >
                                    <Box
                                        sx={{
                                            color: palette.nav.font,
                                            display: "flex",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            gap: "5px"
                                        }}>
                                        <Box sx={{ background: isActive ? palette.nav.activeSidebarItem : "none", color: isActive ? palette.nav.activeFont : palette.nav.font, fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", borderRadius: 10, "&:hover": { background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem } }}>{item.icon}</Box>
                                        <Typography
                                            sx={{
                                                color: "inherit",
                                                fontSize: "12px",
                                                textAlign: "center"
                                            }}>{item.label}</Typography>
                                    </Box>
                                </Link>
                            </Box>
                        )
                    } )}
                    <Box
                        onClick={() => setMenuState( true )}
                        sx={{
                            color: palette.nav.font,
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "5px",
                            cursor: "pointer"
                        }}>
                        <Box
                            sx={{
                                fontSize: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>{Icons.default.Menu}</Box>
                        <Typography
                            color={palette.nav.font}
                            sx={{
                                fontSize: "12px",
                                textAlign: "center"
                            }}>More</Typography>
                    </Box>
                </Box>
                <SwipeableDrawer
                    sx={{ background: "transparent", zIndex: { sm: "initial", xs: "120000" }, overflow: "hidden", width: menuState ? sidebarWidth : 0, flexSrink: 0, display: { xs: "flex", sm: "none" }, flexDirection: "column" }}
                    anchor="bottom"
                    open={menuState}
                    className="no-scrollbar"
                    keepMounted={false}
                    swipeAreaWidth={0}
                    onClose={() => setMenuState( false )}
                    onOpen={() => setMenuState( true )}
                    slotProps={{
                        paper: { className: "no-scrollbar", sx: { borderRadius: `${layout.borderRadius * 4 + "px"} ${layout.borderRadius * 4 + "px"} 0 0`, background: palette.nav.sidebar, borderRight: "none", maxHeight: "80%" } }
                    }}
                >
                    <Box sx={{ position: "relative", width: "100%", my: 1 }}>
                        <Box sx={{ position: "absolute", left: "50%", transform: `translateX(-50%)`, height: 10, borderRadius: 5, width: 80, bgcolor: palette.action.selected }} />
                    </Box>
                    <Box
                        sx={{
                            position: "relative",
                            flexGrow: 1,
                            overflow: "auto",
                            display: "flex"
                        }}>
                        <Box
                            className="sidebar-scrollbar"
                            sx={{
                                display: "grid",
                                gridTemplateColumns: "repeat(3,1fr)",
                                padding: "40px 20px",
                                flexWrap: "wrap",
                                width: "100%",
                                gap: "30px",
                                justifyContent: "space-evenly",
                                overflow: "auto",
                                color: "GrayText",
                                alignItems: "stretch"
                            }}>
                            {menu.filter( item => item.view.includes( "opened-bottom-bar" ) ).map( item => {
                                const isActive = item.children ? item.activeMatchRegexes.flat().some( re => active.match( re ) ) : item.activeMatchRegexes.some( re => active.match( re ) )
                                return (
                                    <Box key={item.id}>
                                        <Link to={item.link} className='default-link' >
                                            <Box
                                                sx={{
                                                    color: palette.nav.font,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    gap: "5px"
                                                }}>
                                                <Box sx={{ background: isActive ? palette.nav.activeSidebarItem : "none", color: isActive ? palette.nav.activeFont : palette.nav.font, fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px", borderRadius: 10, "&:hover": { background: !isActive ? palette.nav.sidebarItemHoverBg : palette.nav.activeSidebarItem } }}>{item.icon}</Box>
                                                <Typography
                                                    sx={{
                                                        color: "inherit",
                                                        fontSize: "12px",
                                                        textAlign: "center"
                                                    }}>{item.label}</Typography>
                                            </Box>
                                        </Link>
                                    </Box>
                                )
                            } )}
                        </Box>
                    </Box >
                </SwipeableDrawer >
            </Box>
        </Box >
    )
}

export default SideDrawer

